import {ModalController} from '../common/modal.controller.js';

class PregledController {
    constructor($uibModal, Model) {
        this.$uibModal = $uibModal;
        this.ModelFactory = Model;
        this.items = [];
        this.pager = {
            currentPage: 1,
            limit: 15,
            totalItems: 0,
            search: "",
        };

        this.refreshState();
    }

    refreshState() {
        this.getItems();
    }

    insert() {
        const model = {};
        const modal = this.$uibModal.open({
            template: '<pregled-form model="vm.model" on-submit="vm.submit(model)" on-cancel="vm.cancel()"></pregled-form>',
            controller: ModalController,
            controllerAs: 'vm',
            resolve : {
                model: function() {
                    return model;
                }
            },
        });

        modal.result.then((model) => {
            this.refreshState();
        });
    }

    edit(item) {
        const model = item;
        const modal = this.$uibModal.open({
            template: '<pregled-form model="vm.model" on-submit="vm.submit(model)" on-cancel="vm.cancel()"></pregled-form>',
            controller: ModalController,
            controllerAs: 'vm',
            backdrop: 'static',
            resolve : {
                model: function() {
                    return model;
                }
            },
        });

        modal.result.then((model) => {
            this.refreshState();
        });
    }

    getItems() {
        const params = {
            limit: this.pager.limit,
            offset: 0,
            search: this.pager.search,
        };

        if (params.search === '') {
            delete (params.search);
        }

        params.offset = (this.pager.currentPage - 1) * params.limit;

        this.ModelFactory.findAll(params, {bypassCache: true}).then((response) => {
            this.items = response;
            if (angular.isDefined(response.meta)) {
                this.pager.totalItems = response.meta.count;
            }
        });
    }

    onFilter(value) {
        this.pager.search = value;
        this.refreshState();
    }

    pageChanged() {
        this.refreshState();
    }

}

PregledController.$inject = ['$uibModal', 'Pregled'];

export {PregledController};



// WEBPACK FOOTER //
// ./app/components/pregled/pregled.controller.js